import { BlockRichText } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { SuperRichText } from './SuperRichText'

export const RichTextBlock: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockRichText
    customProps?: any
  }>
> = ({ block, customProps }) => {
  const { richText, textAlignCenter, superscript, superscriptFontSize } = block
  const blackBackground = !!customProps?.blackBackground
  if (!richText) return null

  return (
    <>
      {superscript && (
        <div
          style={{
            fontSize: superscriptFontSize ? superscriptFontSize : '100%',
          }}
        >
          {superscript}
        </div>
      )}
      <SuperRichText
        richText={richText}
        blackBackground={blackBackground}
        textAlignCenter={textAlignCenter}
      />
    </>
  )
}
